import type { Task } from '../../types/models';
import { TaskCheckbox } from '../TaskCheckbox';
import { DuePill } from '../Pills';
import { BoltIcon, CursorSpark } from '../Icon';
import styles from './TaskRow.module.css';

interface TaskRowProps {
  task: Task;
  projectName?: string;
  onToggle: () => void;
  onCursor: () => void;
  onOpen: () => void;
  onToggleLineup?: () => void;
}

/** Compact inline task row used inside a client card. */
export function TaskRow({ task, projectName, onToggle, onCursor, onOpen, onToggleLineup }: TaskRowProps) {
  return (
    <div className={styles.row}>
      <TaskCheckbox done={task.done} onToggle={onToggle} label={`Complete: ${task.title}`} />
      <button type="button" className={styles.body} onClick={onOpen}>
        <div className={styles.title}>{task.title}</div>
        <div className={styles.metaRow}>
          {task.dueLabel && <DuePill due={task.due} label={task.dueLabel} />}
          {projectName && <span className={styles.metaText}>{projectName}</span>}
          {task.est && <span className={styles.metaText}>· {task.est}</span>}
        </div>
      </button>
      {task.ai && (
        <button
          type="button"
          className={styles.agentBtn}
          onClick={onCursor}
          title="Hand to agent"
          aria-label="Hand to Cursor"
        >
          <CursorSpark size={13} />
        </button>
      )}
      {onToggleLineup && (
        <button
          type="button"
          className={`${styles.lineupBtn} ${task.inLineup ? styles.lineupOn : ''}`}
          onClick={onToggleLineup}
          title={task.inLineup ? 'Remove from Lineup' : 'Add to Lineup'}
          aria-label={task.inLineup ? 'Remove from Lineup' : 'Add to Lineup'}
          aria-pressed={task.inLineup ?? false}
        >
          <BoltIcon size={13} />
        </button>
      )}
    </div>
  );
}
